import type { AgentType } from '@/lib/types/ai-agent';

export const DEFAULT_INTERVIEW_FLOW = 'interview_default';
export const DEFAULT_SALES_FLOW = 'demo_pitch';

export function getDefaultFlowName(agentType: AgentType): string {
  return agentType === 'sales' ? DEFAULT_SALES_FLOW : DEFAULT_INTERVIEW_FLOW;
}

export function normalizeFlowName(
  flowName: string | null | undefined,
  agentType: AgentType,
): string {
  const normalized = (flowName || '').trim();
  if (normalized.length > 0) {
    return normalized;
  }
  return getDefaultFlowName(agentType);
}
